import React from 'react';
import Image from '../../loggedout/common/Image';
import * as S from './style';

import { getData, getGradeMap, t2GradeData } from "./data";
import StarRating from '~images/loggedout/review-images/star_rating.png';
import LogoImage from "~images/loggedout/home/splash_logo.svg";
import ReviewImage from '~images/mela-purchase/reviews/dummy-parent.png';
import { getItemFromLocalStorage } from '../../../utils/web-helper';

function Reviews({ settings }) {
  let grade = settings.student_courses && settings.student_courses[0].grade_code || settings.grade_code || 'pk';
  const reviewContentByGrade = getItemFromLocalStorage('live_class_tab_visible') ? t2GradeData() : getData();
  const gradeMap =  getGradeMap();

  return (
    <S.ReviewContainer>
      <S.LogoImage>
        <Image src={LogoImage} />
      </S.LogoImage>
      <S.Reviews>
        <S.ExtraInfoContent>
          {reviewContentByGrade[grade].map((item) => {
            return (
              <S.Review>
                <S.ImageWrapper>
                  <Image src={item.image || ReviewImage} isCdnImage={item.isCdn} />
                </S.ImageWrapper>
                <S.ParentInfoWrap>
                  <S.Title>{item.data}</S.Title>
                  <S.ExtraInfoWrapper>
                    <div>
                      <S.Name>{item.name}</S.Name>
                      <S.Grade>Parent, {item.grade || gradeMap[grade]}</S.Grade>
                    </div>
                    <S.RatingImagWrapper>
                      <Image src={StarRating} />
                    </S.RatingImagWrapper>
                  </S.ExtraInfoWrapper>
                </S.ParentInfoWrap>
              </S.Review>
            )
          })}
        </S.ExtraInfoContent>
      </S.Reviews>
    </S.ReviewContainer>
  )
}

export default Reviews
